export default "__VITE_ASSET__GyrZSVtq__"